import { Empty } from 'antd'
import { MessagesAreaProps } from 'features/drilldown/panels/global/llmPanel/types'
import { Sparkles } from 'lucide-react'
import React, { FC, useEffect, useRef } from 'react'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

import { LoadingMessage } from './LoadingMessage'
import { MessageBubble } from './MessageBubble'

const MessagesContainer = styled.div`
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  min-height: 0;
  max-height: 500px;
`

export const MessagesArea: FC<MessagesAreaProps> = ({
  messages,
  showTimestamps,
  isLoading,
  onCopy,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null)

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages, isLoading])

  const hasMessages = messages.length > 0

  return (
    <MessagesContainer>
      {!hasMessages ? (
        <Empty
          image={<Sparkles size={48} />}
          description='Start a conversation'
          style={{ color: CantileverTheme.colors.purple['400'] }}
        />
      ) : (
        messages.map((message) => (
          <MessageBubble
            key={message.id}
            message={message}
            showTimestamp={showTimestamps}
            onCopy={onCopy}
          />
        ))
      )}
      {isLoading && <LoadingMessage />}
      <div ref={messagesEndRef} />
    </MessagesContainer>
  )
}
